const baseUrl = process.env.REACT_APP_API_URL + '/translations';

export const getTranslations = async (): Promise<any> => {
    const response = await fetch(baseUrl);
    const result = await response.json();

    return result;
};
